import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {ApiAgentService} from '../../../services/api-agent.service';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {EnvironmentService} from '../../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MyBusiness} from '../../../models/my-business';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {Partner} from '../../../models/partner';
import {CommonModule} from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-bank-update',
  templateUrl: './bank-update.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./bank-update.component.scss']
})
export class BankUpdateComponent implements OnInit {

  submitting;
  submitted;
  form: FormGroup;

  myBusiness: MyBusiness;
  bankName: string;
  lang: any;
  loading: any;
  myPartners: Partner[];

  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;

  checkPermission() {
    let perms = this.env.checkPermission(this.myBusiness.subAccountType, this.myBusiness.subAccountGovId);
    this.isAccountant = perms.isAccountant;
    this.isSales = perms.isSales;
    this.isManager = perms.isManager;
    this.isMerchant = perms.isMerchant;
  }

  constructor(private loader: GlobalLoaderService,
              private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }
  // @ts-ignore
  get f() {
    return this.form.controls;
  }


  async ngOnInit() {

    this.loading = true;

    this.form = this.formBuilder.group({
      licenseName: ['', [Validators.required]],
      iban: [null],
      ibanBank: [null]
    });

    // @ts-ignore
    this.form.get('licenseName').disable();
    // @ts-ignore
    this.form.get('iban').disable();
    // @ts-ignore
    this.form.get('ibanBank').disable();

    this.myBusiness = await this.api.getMyBusiness(false);


    // get bank name of IBAN info
    let bankNames = await this.api.getBankNames();
    for (let bank of bankNames) {
      if (bank.bankName == this.myBusiness.ibanBank) {
        this.bankName = bank.bankNameAr;
        break;
      }
    }

    this.form.patchValue({
      licenseName: this.myBusiness.licenseName,
      iban: this.myBusiness.iban != undefined && this.myBusiness.iban != '' && this.myBusiness.iban != null ? this.myBusiness.iban : null,
      ibanBank: this.bankName != null && this.bankName != '' ? this.bankName : (this.myBusiness.ibanBank != null ? this.myBusiness.ibanBank : null),
    });

    // get api settings
    this.checkPermission();

    setTimeout(async () => {
      await this.loadResources();
      this.loading = false;
      this.lang = await firstValueFrom(this.translate.get('lang'));

    }, 1000);
  }

  async close() {
    window.location.href = '/private/settings';
  }


  // noinspection DuplicatedCode
  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalStyles('/plugins/dropify/dropify.min.css');
    await this.loader.loadExternalStyles('/assets/css/users/account-setting.css');
    await this.loader.loadExternalScript('/plugins/dropify/dropify.min.js');
    await this.loader.loadExternalScript('/plugins/blockui/jquery.blockUI.min.js');
    await this.loader.loadExternalScript('/assets/js/users/account-settings.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/datatables.js');
    await this.loader.loadExternalStyles('/plugins/table/datatable/datatables.css');

    $('.dropify').dropify({
      messages: {
        'default': await this.translate.get('Click to Upload or Drag n Drop').toPromise(),
        'remove': '<i class="flaticon-close-fill"></i>',
        'replace': await this.translate.get('Upload or Drag n Drop').toPromise()
      }
    });
  }

  fileName: string;

}
